module.exports = __webpack_public_path__ + "media/images/game/task/abc-8d1e0f7ca3fb73d7e3c3aa6f7d446907.png";